export default {
  name: 'Datepicker',
  props: ['value', 'disabled'],
  data () {
    return {
      content: this.value
    };
  },
  methods: {
    clearSearch () {
      this.content = '';
      this.updateValue();
    },
    updateValue () {
      this.$emit('input', this.content)
    }
  }
}
